import { spApi } from './sp';

export const affiliateApi = spApi.injectEndpoints({
  endpoints: (builder) => ({
    setAffiliateAttribution: builder.mutation({
      query: ({ code, captured_at }) => ({
        url: '/affiliate/attribution',
        method: 'POST',
        body: { code, captured_at },
      }),
    }),
  }),
  overrideExisting: false,
});

export const { useSetAffiliateAttributionMutation } = affiliateApi;